import { gql } from '@apollo/client'
import { Modal, VisuallyHidden } from '@farol-ds/react'
import classNames from 'classnames'
import { ReactNode } from 'react'

import { useSendViewItemEvent } from '../../../../hooks/use-send-view-item-event'
import { useModalContext } from '../../../context'
import { ModalLock_OfferLockDataFragment } from './__generated__/modal-lock.graphql'
import styles from './modal-lock.module.scss'

export interface ModalLockProps {
  children: ReactNode
  offerLockData: ModalLock_OfferLockDataFragment
}

export function ModalLock({ children, offerLockData }: ModalLockProps) {
  const { header, body } = offerLockData
  const title = header?.title
  const subtitle = header?.subtitle
  const { open, setOpen } = useModalContext()
  const { sendViewItemRef } = useSendViewItemEvent({ offerLockBody: body })

  const quantityOfOffers = body?.cards?.length
  const isOneOfferForFrequency = quantityOfOffers < 6

  const modalContentClassName = classNames({
    [styles.modalContent]: !isOneOfferForFrequency,
  })

  return (
    <Modal size={isOneOfferForFrequency ? 'md' : 'lg'} open={open} onOpenChange={setOpen}>
      <Modal.Content data-testid="modal-lock-content" containerClassName={modalContentClassName}>
        <Modal.IconClose data-testid="modal-lock-icon-close" />

        <Modal.Header data-testid="modal-lock-header">
          <VisuallyHidden>Jusbrasil</VisuallyHidden>
          <Modal.HeaderTitle>{title}</Modal.HeaderTitle>
          <Modal.HeaderDescription>{subtitle}</Modal.HeaderDescription>
        </Modal.Header>

        <VisuallyHidden>
          <h1>Assine o Jusbrasil</h1>
        </VisuallyHidden>

        <Modal.Body data-testid="modal-lock-body" ref={sendViewItemRef}>
          {children}
        </Modal.Body>
      </Modal.Content>
    </Modal>
  )
}

ModalLock.fragments = {
  offerLockData: gql`
    fragment ModalLock_offerLockData on OfferLockData {
      header {
        title
        subtitle
      }
      body {
        ...UseSendViewItemEvent_offerLockBody
      }
    }

    ${useSendViewItemEvent.fragments.offerLockBody}
  `,
}
